module.exports = __webpack_public_path__ + "static/media/unifi.15c8aeb2.png";